"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.peaksWidth = peaksWidth;
const ml_regression_power_1 = require("ml-regression-power");
const ml_spectra_processing_1 = require("ml-spectra-processing");
function peaksWidth(peaks) {
    let xs = peaks.map((peak) => peak.x);
    let widths = peaks.map((peak) => peak.width);
    if (xs.length < 2) {
        throw new Error(`peaksWidth: not enough peaks (less than 2) for automatic width calculation: ${xs.length}`);
    }
    let regression = new ml_regression_power_1.PowerRegression(xs, widths);
    if (Number.isNaN(regression.A) || Number.isNaN(regression.B)) {
        throw new Error('peaksWidth: can not calculate regression');
    }
    let from = (0, ml_spectra_processing_1.xMinValue)(xs);
    let to = (0, ml_spectra_processing_1.xMaxValue)(xs);
    let regressionChart = { x: [], y: [] };
    for (let x = from; x <= to; x += (to - from) / 1000) {
        regressionChart.x.push(x);
        regressionChart.y.push(regression.predict(x));
    }
    return {
        widths: {
            x: xs,
            y: widths,
        },
        fit: regressionChart,
        score: regression.score(xs, widths),
        predictFct: regression.predict.bind(regression),
        tex: regression.toLaTeX(3),
        A: regression.A,
        B: regression.B,
        predictFctString: `${regression.A} * mass ** ${regression.B}`,
    };
}
//# sourceMappingURL=peaksWidth.js.map